import type { AppState, ArcadeBest, ArcadeMode } from "./types";

// Pure mutators for the arcade best-score table. `score` semantics are
// per-mode (see ArcadeBest's comment in types.ts) — this module is just
// the storage layer and doesn't care.

const keyFor = (mode: ArcadeMode, region: string): string =>
  `${mode}:${region}`;

export const getArcadeBest = (
  state: AppState,
  mode: ArcadeMode,
  region: string,
): ArcadeBest | null => state.arcadeBests[keyFor(mode, region)] ?? null;

// Returns a new state if the score beat the existing best; otherwise
// returns the state unchanged. Tie scores do not replace the existing
// timestamp.
export const recordArcadeScore = (
  state: AppState,
  mode: ArcadeMode,
  region: string,
  score: number,
  now: number,
): { state: AppState; isNewBest: boolean } => {
  const existing = state.arcadeBests[keyFor(mode, region)];
  if (existing && existing.score >= score) {
    return { state, isNewBest: false };
  }
  return {
    state: {
      ...state,
      arcadeBests: {
        ...state.arcadeBests,
        [keyFor(mode, region)]: { score, achievedAt: now },
      },
    },
    isNewBest: true,
  };
};
